export enum DateRestrictionTypes {
  mostRecentValue = 'mostRecentValue',
  ever = 'ever',
  inAnyPeriod = 'inAnyPeriod',
  inAllPeriods = 'inAllPeriods',
  contemporaneous = 'contemporaneous'
}